import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ badge, title, sub, testId }) {
  return (
    <div className="max-w-2xl">
      <Reveal>
        <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-cyan-400">
          {badge}
        </span>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          data-testid={testId}
          className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1]"
        >
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
